import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../assets/images/logo-badge.png";

const css = `
.gfs-top{background:var(--navy-deep);color:var(--silver);font-size:14px}
.gfs-top .container{display:flex;justify-content:space-between;align-items:center;gap:16px;min-height:38px;flex-wrap:wrap}
.gfs-top a{text-decoration:none;color:var(--silver)}
.gfs-top a:hover{color:#fff}
.gfs-top-left,.gfs-top-right{display:flex;gap:22px;flex-wrap:wrap}
.gfs-nav{position:sticky;top:0;z-index:100;background:#fff;border-bottom:1px solid #E3E8ED;box-shadow:0 2px 14px rgba(15,34,56,.06)}
.gfs-nav .container{display:flex;align-items:center;justify-content:space-between;min-height:82px}
.gfs-brand{display:flex;align-items:center;gap:14px;text-decoration:none}
.gfs-brand img{width:58px;height:58px}
.gfs-brand-text{display:flex;flex-direction:column;line-height:1.1}
.gfs-brand-text strong{font-family:var(--font-head);font-weight:800;font-size:21px;color:var(--navy);letter-spacing:.5px}
.gfs-brand-text span{font-size:12.5px;color:var(--muted);letter-spacing:.4px;margin-top:3px}
.gfs-links{display:flex;align-items:center;gap:6px;list-style:none;margin:0;padding:0}
.gfs-links a.gfs-link{display:block;padding:10px 16px;font-family:var(--font-head);font-weight:600;font-size:15px;color:var(--navy);text-decoration:none;border-bottom:3px solid transparent}
.gfs-links a.gfs-link:hover{color:var(--navy-soft)}
.gfs-links a.gfs-link.active{border-bottom-color:var(--gold)}
.gfs-links .btn{margin-left:12px;padding:12px 22px}
.gfs-burger{display:none;background:none;border:0;padding:8px;cursor:pointer}
.gfs-burger span{display:block;width:26px;height:3px;background:var(--navy);margin:5px 0;transition:transform .25s,opacity .25s}
.gfs-burger.open span:nth-child(1){transform:translateY(8px) rotate(45deg)}
.gfs-burger.open span:nth-child(2){opacity:0}
.gfs-burger.open span:nth-child(3){transform:translateY(-8px) rotate(-45deg)}
@media (max-width:900px){
  .gfs-top-left span.hide-sm,.gfs-top-right{display:none}
  .gfs-burger{display:block}
  .gfs-links{position:absolute;top:100%;left:0;right:0;background:#fff;flex-direction:column;align-items:stretch;padding:12px 24px 24px;gap:0;border-bottom:1px solid #E3E8ED;display:none}
  .gfs-links.open{display:flex}
  .gfs-links a.gfs-link{padding:14px 0;border-bottom:1px solid var(--mist)}
  .gfs-links .btn{margin:16px 0 0;text-align:center}
}
`;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const cls = ({ isActive }) => "gfs-link" + (isActive ? " active" : "");

  return (
    <>
      <style>{css}</style>
      <div className="gfs-top">
        <div className="container">
          <div className="gfs-top-left">
            <a href="tel:07459262621">Call: 07459 262621</a>
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=guardianfacilityservicesltd@gmail.com" target="_blank" rel="noopener noreferrer" className="hide-sm">guardianfacilityservicesltd@gmail.com</a>
          </div>
          <div className="gfs-top-right">
            <span>Mon-Fri 7:30am - 8:00pm | Sat 9:00am - 5:00pm</span>
          </div>
        </div>
      </div>
      <header className="gfs-nav">
        <div className="container">
          <Link to="/" className="gfs-brand" onClick={close} aria-label="Guardian Facility Services home">
            <img src={logo} alt="GFS logo" />
            <span className="gfs-brand-text">
              <strong>GUARDIAN</strong>
              <span>Facility Services Ltd</span>
            </span>
          </Link>
          <button className={"gfs-burger" + (open ? " open" : "")} onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open}>
            <span></span><span></span><span></span>
          </button>
          <ul className={"gfs-links" + (open ? " open" : "")}>
            <li><NavLink to="/" end className={cls} onClick={close}>Home</NavLink></li>
            <li><NavLink to="/about" className={cls} onClick={close}>About Us</NavLink></li>
            <li><NavLink to="/services" className={cls} onClick={close}>Our Services</NavLink></li>
            <li><NavLink to="/contact" className={cls} onClick={close}>Contact Us</NavLink></li>
            <li><Link to="/contact" className="btn btn-gold" onClick={close}>Get a Free Quote</Link></li>
          </ul>
        </div>
      </header>
    </>
  );
}